import { COIN_FULL_NAME, IBlockchainStatus } from './../../../../models/Crypto';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '../../../../services/api.service';
import { CryptoService } from '../../../../abstraction/crypto.service';
import { DataLayerService } from '../../../../services/utils/data-layer.service';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import { AuthService } from '../../../../abstraction/auth.service';
import { TransactionChain, TransactionType } from 'src/app/pages/core/models/Transactions';

@Component({
  selector: 'app-deposit-crypto',
  templateUrl: './deposit-crypto.component.html',
  styleUrls: ['./deposit-crypto.component.scss'],
})
export class DepositCryptoComponent implements OnInit {
  cryptoSelected: FormControl = new FormControl('USDT');
  addressLoading = true;
  depositableCoins: string[] = [];

  // QR
  elementType = NgxQrcodeElementTypes.URL;
  correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  qrValue = '';
  address = '-';

  copied = false;
  @Input()
  depositStep;
  @Output()
  backEvent: EventEmitter<void> = new EventEmitter();

  private blockchainStatuses: IBlockchainStatus[] = [];

  constructor(
    public auth: AuthService,
    public api: ApiService,
    public matDialog: MatDialog,
    public dialogRef: MatDialogRef<DepositCryptoComponent>,
    public cryptoS: CryptoService,
  ) {}

  ngOnInit(): void {
    this.setAddress(this.auth.loggedUser.cryptoAddress);
    this.addressLoading = false;

    this.cryptoS.getBlockchainStatus().subscribe((res) => {
      this.blockchainStatuses = res;
    });
  }

  setAddress(address: string) {
    this.address = address;
    this.qrValue = address;
  }

  getMinDeposit(ticker) {
    if (ticker === 'DAI') {
      return 10;
    } else {
      return Math.ceil((10 / +this.cryptoS.prices.value[ticker + '_DAI'].buy) * 1000) / 1000;
    }
  }

  copyCBUToClipboard() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.address;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.copied = true;
    setTimeout(() => {
      this.copied = false;
    }, 2000);
  }

  goToDepositStep(step: number) {
    this.depositStep = step;
    if (this.depositStep === 3) {
      this.setAddress(this.auth.loggedUser.cryptoAddress);
      this.depositableCoins = this.filterCoinsByStatus(
        TransactionChain.BSC,
        this.cryptoS.depositableCoins.BSC,
      ).sort((a, b) => {
        if (a === 'USDT') return -1;
      });
    } else if (this.depositStep === 4) {
      this.setAddress(this.auth.loggedUser.cryptoAddress);
      this.depositableCoins = this.filterCoinsByStatus(
        TransactionChain.ETHEREUM,
        this.cryptoS.depositableCoins.ETH,
      ).sort((a, b) => {
        if (a === 'USDT') return -1;
      });
    } else if (this.depositStep === 7) {
      this.setAddress(this.auth.loggedUser.cryptoAddress);
      this.depositableCoins = this.filterCoinsByStatus(
        TransactionChain.POLYGON,
        this.cryptoS.depositableCoins.POLYGON,
      ).sort((a, b) => {
        if (a === 'USDT') return -1;
      });
    }
    this.cryptoSelected.setValue(this.depositableCoins[0] || '');
  }

  close() {
    this.matDialog.closeAll();
  }

  back() {
    this.backEvent.emit();
  }

  getCoinFullName(ticker: string) {
    if (ticker === 'STABLES') {
      return 'DAI, BUSD o USDC';
    }
    if (ticker === 'USDC') {
      return COIN_FULL_NAME[ticker] + ' (Nativo)';
    }
    return COIN_FULL_NAME[ticker];
  }

  filterCoinsByStatus(chain: number, coinsToFilter: string[]) {
    const coinStatuses = this.blockchainStatuses.find((blockchain) => {
      return chain === blockchain.chain && blockchain.type === TransactionType.DEPOSIT;
    })?.coins;

    return coinsToFilter.filter((coin) => {
      return coinStatuses[coin];
    });
  }
}
